<template>
    <div v-if="vereinsdatenblatt" >
        <div v-if="!$vuetify.breakpoint.xsOnly" class="body-2">
            <table>
                <tr style="vertical-align: top">
                    <td :width="small?'64px':'90px'"
                        :class="[headerClass, {'labelCell': small}]"></td>
                    <td :class="[headerClass, {'labelCell': small}]">Obmann/Obfrau</td>
                    <td :class="[headerClass, {'borderRight labelCell': small && !smallPrint},
                                              {'borderRightPrint labelCell': smallPrint}]">Sektionsleiter/in</td>
                </tr>
                <tr style="vertical-align: top" v-for="(personRow, i) in personRows" :key="i">
                    <td :class="[cellClass, 'font-weight-bold labelCell',
                                {'borderBottom': personRow.field==='email' && !small}]">{{personRow.label}}</td>
                    <td :class="[cellClass, {'borderRight': person==='sektionsleiter' && !smallPrint},
                                {'borderRightPrint': person==='sektionsleiter' && smallPrint},
                                {'borderBottom': personRow.field==='email' && !small}]"
                        v-for="(person) in persons" :key="person">
                        {{vereinsdatenblatt[person][personRow.field]}}
                    </td>
                </tr>
            </table>
            <table :class="[{'mt-3': !small}]">
                <tr style="vertical-align: top">
                    <td>
                        <table>
                            <tr style="vertical-align: top">
                                <!--<td :width="small?'64px':'90px'"
                                    :class="[headerClass, {'labelCell': small}]"></td>-->
                                <td :class="[headerClass, 'text-center',
                                {'labelCell borderRight': small && !smallPrint},
                                {'labelCell borderRightPrint': smallPrint}]"
                                    colspan="2">Sportanlage</td>
                            </tr>
                            <tr style="vertical-align: top" v-for="(sportanlageRow, i) in sportanlageRows" :key="i">
                                <td :width="small?'64px':'90px'"
                                    :class="[cellClass, 'font-weight-bold labelCell']">
                                    {{sportanlageRow.label}}</td>
                                <td :class="[cellClass, {'borderRight': !smallPrint}, {'borderRightPrint': smallPrint}]">
                                    {{vereinsdatenblatt.sportanlage[sportanlageRow.field]}}
                                </td>
                            </tr>
                            <tr style="vertical-align: top">
                                <td :class="[cellClass, 'font-weight-bold labelCell',{'borderBottom': (!smallPrint && !small) ||
                                                 (small && vereinsdatenblatt.sportkapitaene.length===0 )},
                                {'borderBottomPrint': smallPrint && vereinsdatenblatt.sportkapitaene.length===0}]" rowspan="2">Bahnen</td>
                                <td :class="[cellClass, {'borderRight': !smallPrint},
                                {'borderRightPrint': smallPrint}]">Für 4er-Mannschaften von
                                    {{vereinsdatenblatt.sportanlage.bahnen?.viererTeam?.von ?
                                        vereinsdatenblatt.sportanlage.bahnen?.viererTeam?.von : 1}} bis
                                    {{vereinsdatenblatt.sportanlage.bahnen?.viererTeam?.bis ?
                                        vereinsdatenblatt.sportanlage.bahnen?.viererTeam?.bis : 4}}</td>
                            </tr>
                            <tr style="vertical-align: top">
                                <td :class="[cellClass, {'borderRight': !smallPrint},
                                {'borderRightPrint': smallPrint}, {'borderBottom': (!smallPrint && !small) ||
                                                 (small && vereinsdatenblatt.sportkapitaene.length===0 )},
                                {'borderBottomPrint': smallPrint && vereinsdatenblatt.sportkapitaene.length===0 }]">
                                    Für 6er-Mannschaften von
                                    {{vereinsdatenblatt.sportanlage.bahnen?.sechserTeam?.von ?
                                      vereinsdatenblatt.sportanlage.bahnen?.sechserTeam?.von : 1}} bis
                                    {{vereinsdatenblatt.sportanlage.bahnen?.sechserTeam?.bis ?
                                      vereinsdatenblatt.sportanlage.bahnen?.sechserTeam?.bis : 4}}</td>
                            </tr>
                        </table>
                    </td>
                    <td :style="small?'':'width: 20px'"></td>
                    <td>
                        <table >
                            <tr style="vertical-align: top">
                                <!--<td v-if="!small" style="border-left: none"
                                    :class="[headerClass, {'labelCell': small}]"></td>-->
                                <td colspan="2" :class="[headerClass, 'text-center',
                                    {'labelCell borderRight': small && !smallPrint},
                                    {'labelCell borderRightPrint': smallPrint}]"
                                    :style="small?'border-left: none':''">Team</td>
                            </tr>
                            <tr style="vertical-align: top; " v-for="(teamRow, i) in teamRows" :key="i">
                                <td :width="small?'64px':'120px'"
                                    :class="[cellClass, 'font-weight-bold labelCell ',
                                    {'borderBottom': teamRow.field==='uebungsleiter' && !smallPrint},
                                    {'borderBottomPrint': teamRow.field==='uebungsleiter' && smallPrint}]"
                                    :style="small?'border-left: none':''">{{teamRow.label}}</td>
                                <td :class="[cellClass, {'borderRight': !smallPrint},
                                    {'borderRightPrint': smallPrint},
                                    {'borderBottom': teamRow.field==='uebungsleiter' && !smallPrint},
                                    {'borderBottomPrint': teamRow.field==='uebungsleiter' && smallPrint}]">
                                    {{vereinsdatenblatt.trainerTeam[teamRow.field]}}
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <table v-if="vereinsdatenblatt.sportkapitaene.length>0" :class="[{'mt-3': !small}]">
                <tr style="vertical-align: top">
                    <!--<td colspan="2" class="font-weight-bold py-3"></td>-->
                    <td :colspan ="vereinsdatenblatt.sportkapitaene.length + 1"
                        :class="[headerClass, {'borderRight labelCell': small && !smallPrint},
                                              {'borderRightPrint labelCell': smallPrint}]">
                        Sportkapitäne/Sportkapitäninnen</td>
                </tr>
                <tr style="vertical-align: top" v-for="(kapitaenRow, i) in kapitaenRows" :key="i">
                    <td :class="[cellClass, 'font-weight-bold labelCell',
                                {'borderBottom': kapitaenRow.field==='email'}]"
                        :width="small?'64px':'120px'">{{kapitaenRow.label}}</td>
                    <td :class="[cellClass, {'borderRight': j===vereinsdatenblatt.sportkapitaene.length-1 && !smallPrint},
                                {'borderRightPrint': j===vereinsdatenblatt.sportkapitaene.length-1 && smallPrint},
                                {'borderBottom': kapitaenRow.field==='email'}]"
                        v-for="(kapitaen, j) in vereinsdatenblatt.sportkapitaene" :key="j">
                        {{kapitaen[kapitaenRow.field]}}
                    </td>
                </tr>
            </table>
        </div>
        <vereinsdatenblatt-team-mob v-else :vereinsdatenblatt="vereinsdatenblatt" :persons="persons"
                :personRows="personRows" :sportanlageRows="sportanlageRows" :teamRows="teamRows">
        </vereinsdatenblatt-team-mob>
    </div>
</template>

<script>
    import VereinsdatenblattTeamMob from "./vereinsdatenblattTeamMob";

    export default {
        components: {VereinsdatenblattTeamMob},
        name: "vereinsdatenblatt-team",
        props: ['vereinsdatenblatt', 'small', 'smallPrint'],
        computed: {
            headerClass(){
                return  this.smallPrint ? 'tdPrint font10 font-weight-bold' :
                        this.small ? 'td font12 font-weight-bold' :
                                    'pa-2 font-weight-bold';
            },
            cellClass(){
                return this.smallPrint ? 'tdPrint font10 tdWhite' :
                       this.small ? 'td font12 tdWhite' : 'td pa-2 tdWhite';
            },
        },
        data: () => ({
            personRows: [
                {label: 'Name', field: 'name'},
                {label: 'Strasse', field: 'strasse'},
                {label: 'Wohnort', field: 'wohnort'},
                {label: 'Telefon', field: 'telefon'},
                {label: 'Handy', field: 'handy'},
                {label: 'eMail', field: 'email'},
            ],
            kapitaenRows: [
                {label: 'Mannsch.', field: 'team'},
                {label: 'Name', field: 'name'},
                {label: 'Strasse', field: 'strasse'},
                {label: 'Wohnort', field: 'wohnort'},
                {label: 'Telefon', field: 'telefon'},
                {label: 'Handy', field: 'handy'},
                {label: 'eMail', field: 'email'},
            ],
            sportanlageRows: [
                {label: 'Name', field: 'name'},
                {label: 'Strasse', field: 'strasse'},
                {label: 'Ort', field: 'ort'},
                {label: 'Telefon', field: 'telefon'},
                {label: 'Fax', field: 'fax'},
                {label: 'eMail', field: 'email'},
            ],
            teamRows: [
                {label: 'Trainer', field: 'trainer'},
                {label: 'Instruktoren', field: 'instruktor'},
                {label: 'Übungsleiter', field: 'uebungsleiter'},
            ],
            persons: ['obmann', 'sektionsleiter'] //, 'sportkapitaen'
        }),
    }
</script>

<style scoped>
    .labelCell{background-color: #f2f2f2}
    .font12 {font-size: 12px}
    .font10 {font-size: 10px}
    table {width: 100%; border-spacing: 0; table-layout: auto;  }
    .td {border-top: solid 1px #ccc; border-left: solid 1px #ccc;
        padding: 2px 6px;}
    .tdPrint {border-top: solid 1px grey; border-left: solid 1px grey;
        padding: 0 4px;}
    .tdWhite { background-color: white; }
    .borderRight { border-right: 1px solid #ccc}
    .borderRightPrint { border-right: 1px solid grey}
    .borderBottom { border-bottom: 1px solid #ccc}
    .borderBottomPrint { border-bottom: 1px solid grey}
</style>